// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AuthenticatedRouteRouteImport } from './routes/_authenticated/route'
import { Route as AboutRouteImport } from './routes/about'
import { Route as AuthRouteImport } from './routes/auth'
import { Route as ConnectedPortalsRouteImport } from './routes/connected-portals'
import { Route as ContactRouteImport } from './routes/contact'
import { Route as Grade11PastPapersRouteImport } from './routes/grade-11-past-papers'
import { Route as Grade12PastPapersRouteImport } from './routes/grade-12-past-papers'
import { Route as JoinThePilotRouteImport } from './routes/join-the-pilot'
import { Route as PastPapersRouteImport } from './routes/past-papers'
import { Route as PrivacyRouteImport } from './routes/privacy'
import { Route as ProductRouteImport } from './routes/product'
import { Route as TeamRouteImport } from './routes/team'
import { Route as TermsRouteImport } from './routes/terms'
import { Route as AuthenticatedMessagesRouteImport } from './routes/_authenticated/messages'

const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const AuthenticatedRouteRoute = AuthenticatedRouteRouteImport.update({
            id: '/_authenticated',getParentRoute: () => rootRouteImport
          })
const AboutRoute = AboutRouteImport.update({
            id: '/about',path: '/about',getParentRoute: () => rootRouteImport
          })
const AuthRoute = AuthRouteImport.update({
            id: '/auth',path: '/auth',getParentRoute: () => rootRouteImport
          })
const ConnectedPortalsRoute = ConnectedPortalsRouteImport.update({
            id: '/connected-portals',path: '/connected-portals',getParentRoute: () => rootRouteImport
          })
const ContactRoute = ContactRouteImport.update({
            id: '/contact',path: '/contact',getParentRoute: () => rootRouteImport
          })
const Grade11PastPapersRoute = Grade11PastPapersRouteImport.update({
            id: '/grade-11-past-papers',path: '/grade-11-past-papers',getParentRoute: () => rootRouteImport
          })
const Grade12PastPapersRoute = Grade12PastPapersRouteImport.update({
            id: '/grade-12-past-papers',path: '/grade-12-past-papers',getParentRoute: () => rootRouteImport
          })
const JoinThePilotRoute = JoinThePilotRouteImport.update({
            id: '/join-the-pilot',path: '/join-the-pilot',getParentRoute: () => rootRouteImport
          })
const PastPapersRoute = PastPapersRouteImport.update({
            id: '/past-papers',path: '/past-papers',getParentRoute: () => rootRouteImport
          })
const PrivacyRoute = PrivacyRouteImport.update({
            id: '/privacy',path: '/privacy',getParentRoute: () => rootRouteImport
          })
const ProductRoute = ProductRouteImport.update({
            id: '/product',path: '/product',getParentRoute: () => rootRouteImport
          })
const TeamRoute = TeamRouteImport.update({
            id: '/team',path: '/team',getParentRoute: () => rootRouteImport
          })
const TermsRoute = TermsRouteImport.update({
            id: '/terms',path: '/terms',getParentRoute: () => rootRouteImport
          })
const AuthenticatedMessagesRoute = AuthenticatedMessagesRouteImport.update({
            id: '/messages',path: '/messages',getParentRoute: () => AuthenticatedRouteRoute
          })





const AuthenticatedRouteRouteChildren = {
  AuthenticatedMessagesRoute: AuthenticatedMessagesRoute
}

const AuthenticatedRouteRouteWithChildren = AuthenticatedRouteRoute._addFileChildren(AuthenticatedRouteRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,AuthenticatedRouteRoute: AuthenticatedRouteRouteWithChildren,AboutRoute: AboutRoute,AuthRoute: AuthRoute,ConnectedPortalsRoute: ConnectedPortalsRoute,ContactRoute: ContactRoute,Grade11PastPapersRoute: Grade11PastPapersRoute,Grade12PastPapersRoute: Grade12PastPapersRoute,JoinThePilotRoute: JoinThePilotRoute,PastPapersRoute: PastPapersRoute,PrivacyRoute: PrivacyRoute,ProductRoute: ProductRoute,TeamRoute: TeamRoute,TermsRoute: TermsRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)